module.exports = __webpack_public_path__ + "img/Claire-Nambuya.134b2da1.jpeg";